import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11da4125"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-background row items-center justify-center window-height" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 text-center text-secondary" }, " Château Cazalères ", -1))
const _hoisted_3 = { class: "text-h5 text-center text-primary" }
const _hoisted_4 = { class: "text-h5 text-center text-primary" }
const _hoisted_5 = { class: "row flex-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-grey" }, " | ", -1))
const _hoisted_7 = { class: "text-caption text-grey text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_errors = _resolveComponent("errors")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "reset-password-card col-xs-10" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('Ownersportal')), 1),
                _createVNode(_component_q_separator, { spaced: "10px" }),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('Reset password')), 1)
              ]),
              _: 1
            }),
            (_ctx.errors.length > 0)
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_errors, { errors: _ctx.errors }, null, 8, ["errors"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_input, {
                  ref: "emailInputRef",
                  modelValue: _ctx.emailInput,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailInput) = $event)),
                  label: _ctx.t('Email'),
                  rules: [_ctx.required('Email'), _ctx.email],
                  type: "email"
                }, null, 8, ["modelValue", "label", "rules"]),
                _createVNode(_component_q_input, {
                  ref: "passwordRef",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  label: _ctx.t('Password'),
                  rules: [_ctx.required('Password'), _ctx.strongPassword, _ctx.maxLength('Password', 255)],
                  type: "password"
                }, null, 8, ["modelValue", "label", "rules"]),
                _createVNode(_component_q_input, {
                  ref: "passwordConfirmationRef",
                  modelValue: _ctx.passwordConfirmation,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
                  label: _ctx.t('Password confirmation'),
                  rules: [
                            _ctx.required('Password confirmation'),
                            _ctx.strongPassword,
                            _ctx.equalToPassword,
                            _ctx.maxLength('Password confirmation', 255),
                        ],
                  onKeydown: _withKeys(_ctx.resetPassword, ["enter"]),
                  type: "password",
                  class: "q-mb-lg"
                }, null, 8, ["modelValue", "label", "rules", "onKeydown"]),
                _createVNode(_component_q_btn, {
                  label: _ctx.t('Reset'),
                  loading: _ctx.loading,
                  color: "secondary",
                  class: "full-width q-mb-md",
                  onClick: _ctx.resetPassword
                }, null, 8, ["label", "loading", "onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_q_btn, {
                    label: "FR",
                    color: "grey",
                    flat: "",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLang('fr')))
                  }),
                  _hoisted_6,
                  _createVNode(_component_q_btn, {
                    label: "NL",
                    color: "grey",
                    flat: "",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLang('nl')))
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, " Focus Platforms - © " + _toDisplayString(new Date().getFullYear()), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}